function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".poster-organization-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "poster-organization-1",
  d: "M19.59,7.4a6.1,6.1,0,1,0-6.09,6.09A6.1,6.1,0,0,0,19.59,7.4Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "poster-organization-1",
  d: "M23.93,25.79V23.92c-.58-13.84-20.29-13.83-20.86,0v1.87a1.64,1.64,0,0,0,1.64,1.64H22.29A1.64,1.64,0,0,0,23.93,25.79Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "poster-organization-1",
  d: "M54.74,7.4a6.1,6.1,0,1,0-6.09,6.09A6.1,6.1,0,0,0,54.74,7.4Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "poster-organization-1",
  d: "M48.65,13.49A10.44,10.44,0,0,0,38.22,23.92v1.87a1.63,1.63,0,0,0,1.64,1.64H57.43a1.63,1.63,0,0,0,1.64-1.64V23.92A10.43,10.43,0,0,0,48.65,13.49Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "poster-organization-1",
  d: "M13.38,31.06c0-.12,0-.23,0-.35H10.11A21,21,0,0,0,18.66,48a14.56,14.56,0,0,1,1.75-2.79,17.66,17.66,0,0,1-7-14.12Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "poster-organization-1",
  d: "M23.83,14.92a17.82,17.82,0,0,1,14.48,0A13.23,13.23,0,0,1,41,12.57a21.19,21.19,0,0,0-19.79,0,13.45,13.45,0,0,1,2.65,2.35Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "poster-organization-1",
  d: "M48.76,30.71a17.66,17.66,0,0,1-7,14.47A13.64,13.64,0,0,1,43.48,48,21,21,0,0,0,52,30.71Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "poster-organization-1",
  d: "M37.17,37.27a6.09,6.09,0,1,0-6.1,6.09A6.1,6.1,0,0,0,37.17,37.27Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "poster-organization-1",
  d: "M31.07,43.36A10.43,10.43,0,0,0,20.65,53.79v1.87a1.63,1.63,0,0,0,1.64,1.64H39.86a1.63,1.63,0,0,0,1.64-1.64V53.79A10.44,10.44,0,0,0,31.07,43.36Z"
});

var SvgOrganization = function SvgOrganization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 62.15 58.61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrganization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/organization.9d79c7bb.svg";
export { ForwardRef as ReactComponent };